const colours = {
  black: '#000000',
  blue: '#02b7e2',
  darkGrey: '#404041',
  darkLightBorder: '#404041',
  green: '#43ac6a',
  grey: '#8c8c8e',
  hoverGrey: '#e4e7e7',
  lightGrey: '#d8d9d9',
  orange: '#e78d2d',
  red: '#e2001a',
  white: '#ffffff',
  whiteGrey: '#f8f8f8',
}

export default colours
